import * as types from '../actions/action-types';
import initialState from './initial-state';

export default function userAddressReducer(state = initialState.userAddress, action) {
    switch (action.type) {
        case types.SEARCH_ADDRESS_SUCCESS:
            return {
                ...state,
                isUserAddressSearchSuccessful: true,
                suggestedAddresses: action.suggestedAddresses,
                searchAddressMessages: ''
            };
        case types.SEARCH_ADDRESS_ERROR:
            return {
                ...state,
                isUserAddressSearchSuccessful: false,
                suggestedAddresses: [],
                searchAddressMessage: action.searchAddressMessage
            };
        case types.RETRIEVE_ADDRESS_SUCCESS:
            return {
                ...state,
                isUserAddressRetrieveSuccessful: true,
                retrievedUserAddress: action.addressData,
                retrieveAddressMessages: ''
            };
        case types.RETRIEVE_ADDRESS_ERROR:
            return {
                ...state,
                isUserAddressRetrieveSuccessful: false,
                retrievedUserAddress: {},
                retrieveAddressMessages: action.retrieveAddressMessages
            };
        case types.RESET_RETRIEVE_USER_ADDRESS: return {
            ...state,
            isUserAddressRetrieveSuccessful: false,
            retrievedUserAddress: {}
        };
        default:
            return state;
    }
}
